import React, { useContext, useState } from "react";

import { ModalContainer } from "./styled";

import { CoreContext } from "context/CoreContext";
import Button from "components/Form/Button";

export default function ModalCancelCampaign() {
  const { modal, setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);

  const close = () => {
    setModal(null);
  };

  const CancelCampaign = async () => {
    setLoading(true);

    setLoading(false);

    modal?.cleanForm();
    modal?.back();

    close();
  };

  return (
    <>
      <ModalContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            width: "480px",
            height: "275px",
            background: "rgba(255, 255, 255, 1)",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <img
            src="/icons/close.svg"
            width={"10px"}
            height={"10px"}
            style={{ alignSelf: "end", cursor: "pointer" }}
            onClick={close}
          />

          <img
            src="/icons/delete-folder.svg"
            width={"64px"}
            height={"64px"}
            style={{ marginTop: "22px" }}
          />
          <p style={{ margin: 0 }}>
            Você realmente deseja cancelar a criação dessa campanha?
          </p>
          <div style={{ display: "flex", gap: "8px" }}>
            <Button outline primary onClick={CancelCampaign} minWidth={"136px"}>
              CANCELAR
            </Button>
            <Button
              primary
              onClick={close}
              loading={loading}
              minWidth={"fit-content"}
            >
              CONTINUAR EDITANDO
            </Button>
          </div>
        </div>
      </ModalContainer>
    </>
  );
}
